<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <BandejaComponentePaginador
      :icono="icono"
      :titulo="titulo"
      :codigoTitulo="codigoTitulo"
      :subTitulo="subTitulo"
      :cifrasControl="cifrasControl"
      :datosTabla.sync="datosTabla"
      :resource="resource"
      :totalRows="totalRows"
      @_funcionExtra="getObtenerDatosBandeja"
      @_actualizaFecha="actualizarFecha"
    ></BandejaComponentePaginador>
  </div>
</template>

<script>
import BandejaComponentePaginador from "../../components/bandejas/BandejaComponentePaginador.vue";
import Swal from "sweetalert2";

export default {
  name: "bandejaHallazgo",
  components: {
    BandejaComponentePaginador,
  },
  props: {},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    fechaFin: "",
    fechaIncio: "",
    idPaciente: 0,
    datosTabla: [],
    encabezadosPendientes: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true, 
      },
      {
        key: "dtefechaAlta",
        label: "Fecha",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkPacientePTIPresuntivoComponente",
      },
      {
        key: "nombreClinica",
        label: "Clínica",
        sortable: true,
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
        component: "BandejaDiagnosticadorComponente",
      },
      {
        key: "nombreSolcitante",
        label: "OG",
        sortable: true,
      }, 
      {
        key: "cambiarEstatusSinTomadeHdx",
        label: "Cambiar a estatus Sin Toma de Hdx",
        sortable: true,
        component: "BandejaCambiarEstatusEnEsperaComponente", 
      },
    ],
    encabezadosEnproceso: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true, 
      },
      {
        key: "dtefechaAlta",
        label: "Fecha",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkPacientePTIPresuntivoComponente",
      },
      {
        key: "nombreClinica",
        label: "Clínica",
        sortable: true,
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
        component: "BandejaDiagnosticadorComponente",
      },
      {
        key: "nombreSolcitante",
        label: "OG",
        sortable: true,
      },
      {
        key: "regresarPendiente",
        label: "Regresar estatus ",
        sortable: true,
        component: "BandejaRegresarEstatusPendienteComponente", 
      },
      {
        key: "cambiarEstatusSinTomadeHdx",
        label: "Cambiar a estatus Sin Toma de Hdx",
        sortable: true,
        component: "BandejaCambiarEstatusEnEsperaComponente", 
      },
    ],
    encabezadosFinalizados: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true, 
      },
      {
        key: "dtefechaAlta",
        label: "Fecha",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true,
        component: "BandejaLinkPacientePTIPresuntivoComponente",
      },
      {
        key: "nombreClinica",
        label: "Clínica",
        sortable: true,
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
        component: "BandejaDiagnosticadorComponente",
      },
      {
        key: "nombreSolcitante",
        label: "OG",
        sortable: true,
      },
      {
        key: "dtefechaModificacion",
        label: "Fecha de salida de pti",
        component: "BandejaFechaTextoComponente",
      }
      // {
      //   key: "regresarPendiente",
      //   label: "Regresar estatus ",
      //   sortable: true,
      //   component: "BandejaRegresarEstatusPendienteComponente", 
      // },
      // {
      //   key: "cambiarEstatusSinTomadeHdx",
      //   label: "Cambiar a estatus Sin Toma de Hdx",
      //   sortable: true,
      //   component: "BandejaCambiarEstatusEnEsperaComponente", 
      // },
    ],
    encabezadosSinTomadeHdx: [
      {
        key: "nombreTipoSolicitud",
        label: "Tipo de Solicitud",
        sortable: true, 
      },
      {
        key: "dtefechaAlta",
        label: "Fecha",
        sortable: true,
        component: "BandejaFechaTextoComponente",
      },
      {
        key: "idPaciente",
        label: "ID",
        sortable: true,
      },
      {
        key: "nombrePaciente",
        label: "Paciente",
        sortable: true
      },
      {
        key: "nombreClinica",
        label: "Clínica",
        sortable: true,
      },
      {
        key: "nombreDiagnosticador",
        label: "Diagnosticador",
        sortable: true,
        component: "BandejaDiagnosticadorComponente",
      },
      {
        key: "nombreSolcitante",
        label: "OG",
        sortable: true,
      },
      {
        key: "regresarPendiente",
        label: "Regresar estatus ",
        sortable: true,
        component: "BandejaRegresarEstatusPendienteComponente", 
      },
    ],
    cifrasControl: [
      {
        id: 1,
        nombre: "Pendientes",
        cantidad: 0,
        icono: "star",
        layoutTabla: [],
        permiso: "DX_04_ver_pestana_pend",
      },
      {
        id: 2,
        nombre: "En proceso",
        cantidad: 0,
        icono: "star-half",
        layoutTabla: [],
        permiso: "DX_04_ver_pestana_proces",
      },
      {
        id: 3,
        nombre: "Finalizados",
        cantidad: 0,
        icono: "star-fill",
        layoutTabla: [],
        permiso: "DX_04_ver_pestana_fin",
      },
      {
        id: 4,
        nombre: "Sin Toma de Hdx",
        cantidad: 0,
        icono: "star-fill",
        layoutTabla: [],
        permiso: "DX_04_ver_pestana_en_espera",
      },
    ],
    icono: "fa fa-credit-card",
    titulo: "CENTRO DE DIAGNÓSTICO",
    codigoTitulo: "BJ_HDX_CDX",
    subTitulo: "Bandeja de solicitudes PTI",
    resource: {
      permiteCambiarDiagnosticador: null,
      idEstatusSolicitud: null,
      arrayDiagnosticadores: [],
    },
    idEstatusPestañaSeleccionada : 1,
    pagina: 1,
    totalRows: 0
  }),
  methods: {
    getObtenerDatosBandeja(intIdEstuatusSolicitud) {
      let tomaHerramientas = true;
      this.showAlert();
      this.datosTabla = [];
      this.idEstatusPestañaSeleccionada = intIdEstuatusSolicitud;

      if (intIdEstuatusSolicitud === 4){
        tomaHerramientas = false;
      }

      const params = {
        fechaFinal: this.fechaFin,
        fechaIncio: this.fechaInicio,
        idEmpleado: this.idEmpleado,
        intIdEstuatusSolicitud: intIdEstuatusSolicitud,
        idPaciente: this.idPaciente, 
        tomaHerramientas: tomaHerramientas,
        pagina: this.pagina,
      }
      
      this.$http
        .post(
          this.$api +
            "hallazgo/bandeja/obtenerDatosBandeja", params )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray
          this.resource.permiteCambiarDiagnosticador =
            response.data.data.blnPermiteEditar;
          this.resource.idEstatusSolicitud = intIdEstuatusSolicitud;
          this.datosTabla = response.data.data.listaResultados;
          Swal.close();
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        }).finally(() => {
          this.getCifrasPorEstatus();
        }); 
    },
    getCifrasPorEstatus() {
      this.showAlert();
      this.cifrasControl.forEach(c => c.cantidad = 0)
      const params = {
        fechaFinal: this.fechaFin,
        fechaIncio: this.fechaInicio,
        idEmpleado: this.idEmpleado,
        idPaciente: this.idPaciente
      }
      this.$http
        .post(
          this.$api +
            "hallazgo/bandeja/cifrasPorEstatus", params  )
        .then((response) => {
          if (Array.isArray(response.data.data) == true) {
            var data = response.data.data;

            data.forEach((elemento) => {
              if (elemento.idEstatusSolicitud == 1) {
                this.cifrasControl[0].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[0].layoutTabla = this.encabezadosPendientes;
              }
              if (elemento.idEstatusSolicitud == 2) {
                this.cifrasControl[1].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[1].layoutTabla = this.encabezadosEnproceso;
              }
              if (elemento.idEstatusSolicitud == 3) {
                this.cifrasControl[2].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[2].layoutTabla = this.encabezadosFinalizados;
              }
              if (elemento.idEstatusSolicitud == 4) {
                this.cifrasControl[3].cantidad = elemento.noTotalSolcitudes;
                this.cifrasControl[3].layoutTabla = this.encabezadosSinTomadeHdx;
              }
              if(elemento.idEstatusSolicitud ==  this.idEstatusPestañaSeleccionada){
                this.totalRows = elemento.noTotalSolcitudes;
              }
            });
          }
          Swal.close();
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        });
    }, //  ----------------------------

    getObtenerEncargadosClinica() {
      this.showAlert();
      const parametros = {idClinica: this.idClinica}
      this.$http
        .post(
          this.$api +
            "hallazgo/bandeja/obtenerEncargadosClinica", parametros
        )
        .then((response) => {
          //NO devuelve un array asi que no funciona validar isArray

          if (Array.isArray(response.data.data) == true) {
            this.resource.arrayDiagnosticadores = response.data.data;
          }
          Swal.close();
        })
        .catch((error) => {
          console.error(error);
          Swal.close();
        }).finally(() => {
          this.getObtenerDatosBandeja(1);
        });
 
    },
    actualizarFecha(fechaInicio, fechaFin, idPaciente, pagina) {
      if (fechaFin !== null && fechaInicio !== null){
        this.fechaInicio = fechaInicio;
        this.fechaFin = fechaFin;
      }
      this.idPaciente = idPaciente === null ? 0 : idPaciente;
      this.pagina = pagina === null? 1: pagina;
      this.getObtenerDatosBandeja(this.idEstatusPestañaSeleccionada);
    },

    
    showAlert() {
      Swal.fire({
        title: "Se esta cargando la pagina.",
        html: "Espere por favor",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },

    
  },
  mounted() {
    this.getObtenerEncargadosClinica(); 
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    history.forward()
    this.resource = {
      permiteCambiarDiagnosticador: false,
      idEstatusSolicitud: null,
      arrayDiagnosticadores: [],
    };
    this.idEmpleado = this.$localStorageService.getIdEmpleado();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.idUsuario = this.$localStorageService.getIdUsuario();
    var dia1 = new Date();
    dia1.setHours(0, 0, 0, 0);
    dia1.setDate(dia1.getDate() - 1);
    this.fechaInicio = this.$moment(dia1)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    var dia2 = new Date();
    dia2.setHours(23, 60, 59, 999);
    this.fechaFin = this.$moment(dia2)
      .utc()
      .format("YYYY-MM-DD[T]HH:mm:ss[Z]");

  },
  computed: {},
};
</script>
